import { render } from "./Banner.vue?vue&type=template&id=4fddcc0f&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=4fddcc0f&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2543395256/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fddcc0f"]])

export default __exports__